import React, {useState} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import {ButtonLink} from 'sail/Button';

import {useGuide} from '../data/GuideProvider';

const messages = defineMessages({
  copy: {
    id: 'docsApp.integrationBuilder.terminal.copy',
    description: 'Copy label',
    defaultMessage: 'Copy',
  },
  copied: {
    id: 'docsApp.integrationBuilder.terminal.copied',
    description: 'Label to confirm item has been copied',
    defaultMessage: 'Copied',
  },
  unable: {
    id: 'docsApp.integrationBuilder.terminal.unable',
    description: 'Label for unable to perform copy action',
    defaultMessage: 'Unable to copy',
  },
});

export function useCopyText({text, source, ...props}) {
  const {copyValue, fireEvent} = useGuide();

  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(false);

  let icon = 'clipboard';
  let label = <FormattedMessage {...messages.copy} />;
  if (copied) {
    icon = 'check';
    label = props.label || <FormattedMessage {...messages.copied} />;
  } else if (error) {
    icon = 'cross';
    label = <FormattedMessage {...messages.unable} />;
  }

  function onClick() {
    fireEvent('copy_text', {source});

    const copiedVal = copyValue(text);
    setCopied(copiedVal);
    setError(!copiedVal);

    setTimeout(() => {
      setCopied(false);
      setError(false);
    }, 1500);
  }

  return {
    copied,
    icon,
    label,
    onClick,
  };
}

export function CopyTextButton({text, source, ...props}) {
  const {icon, label, onClick} = useCopyText({
    text,
    source,
    label: props.label,
  });

  return <ButtonLink {...props} icon={icon} label={label} onClick={onClick} />;
}
